import type {
  FandomTaxonomyCategoryKey,
  FandomTaxonomyValue,
} from "./../types";

import { validFandomTaxonomyValue } from "./../FandomTaxonomyHelpers";
import { getFandomTaxonomyCategory } from "./getFandomTaxonomyCategory";

export function getValuesFromTaxonomyWithPrefix(
  category: FandomTaxonomyCategoryKey,
  key: string,
): FandomTaxonomyValue[] {
  const FANDOM_TAXONOMY_CATEGORY_PREFIX: Record<
    FandomTaxonomyCategoryKey,
    string
  > = {
    site: "s_",
    page: "p_",
  };

  const fandomTaxonomyCategory = getFandomTaxonomyCategory(category) as Record<
    string,
    FandomTaxonomyValue[] | FandomTaxonomyValue
  >;
  let rawValues = fandomTaxonomyCategory?.[key] ?? [];

  // ensure rawValues is an array
  if (!Array.isArray(rawValues)) {
    rawValues = [rawValues];
  }

  return rawValues.filter(validFandomTaxonomyValue).map((value) => ({
    ...value,
    value: `${FANDOM_TAXONOMY_CATEGORY_PREFIX[category]}${value.value}`,
  }));
}
